module.exports = __webpack_public_path__ + "static/img/model-like7.39c72fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-like7.png
// module id = 7gwr
// module chunks = 36